import React, { ReactNode } from 'react'

interface ContactCardProps {
  href: string
  label: string
  value: string
  icon: ReactNode
  isExternal?: boolean
}

function ContactCard({
  href,
  label,
  value,
  icon,
  isExternal = true,
}: ContactCardProps) {
  return (
    <a
      href={href}
      target={isExternal ? '_blank' : undefined}
      rel={isExternal ? 'noopener noreferrer' : undefined}
      className="group"
    >
      <div className="border border-gray-200 p-4 rounded-md transition-all hover:shadow-md hover:border-gray-300 flex items-center">
        <div className="flex items-center justify-center bg-gray-100 rounded-full w-10 h-10 mr-4 group-hover:bg-gray-200 transition-colors">
          {icon}
        </div>
        <div>
          <div className="text-sm text-gray-500">{label}</div>
          <div className="font-medium">{value}</div>
        </div>
      </div>
    </a>
  )
}

export default ContactCard
